import React, { useState, useEffect } from 'react';
import { Modal, Button, Spinner, Alert, Badge, Row, Col, Card } from 'react-bootstrap';
import { supabaseDataService } from '../services/supabaseService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faCheckCircle, faTimesCircle, faDownload } from '@fortawesome/free-solid-svg-icons';
import DeleteConfirmationModal from './ConfirmationModal';


const SubmissionModal = ({ submission, show, onHide, onDelete }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleString();
    };

    const handleDeleteClick = () => {
        setShowDeleteConfirm(true);
    };
    const handleDeleteConfirm = () => {
        setShowDeleteConfirm(false);
        onDelete(submission);
    };

    const handleDeleteCancel = () => {
        setShowDeleteConfirm(false);
    };

    return (
        <>
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="submission-modal"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="submission-modal">
                    {loading ? 'Loading Submission...' : submission?.summary || 'Submission Details'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div className="text-center py-4">
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                ) : submission ? (
                    <>
                        {error && <Alert variant="danger">{error}</Alert>}
                        <Row className="mb-4">
                            <Col md={8}>
                                <h5>Category:{submission.category || ''}</h5>
                            </Col>
                            <Col md={4} className="text-md-end">
                                <div className="mb-2">
                                    <strong>Created:</strong> {formatDate(submission.created_at)}
                                </div>
                            </Col>
                        </Row>

                        {submission.info && (
                            <>
                                <h6>Content</h6>
                                <Card className="mb-4">
                                    <Card.Body>
                                        <div className="submission-info">{submission.info}</div>
                                    </Card.Body>
                                </Card>
                            </>
                        )}
                        {submission.text && (
                            <>
                                <h6>Text</h6>
                                <Card className="mb-4">
                                    <Card.Body>
                                        <pre className="submission-text">{submission.text}</pre>
                                    </Card.Body>
                                </Card>
                            </>
                        )}

                    </>
                ) : (
                    <Alert variant="danger">
                        Submission not found or you don't have permission to view it.
                    </Alert>
                )}
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                {submission && (
                    <>
                        <div >
                            <Button variant="danger" onClick={handleDeleteClick}>
                                Delete
                            </Button>
                        </div>
                    </>
                )}
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
            <DeleteConfirmationModal
                show={showDeleteConfirm}
                onHide={handleDeleteCancel}
                onConfirm={handleDeleteConfirm}
                title={submission?.summary || 'Untitled Submission'}
                subtitle={`Created: ${formatDate(submission?.created_at)}`}
                message="Are you sure you want to delete this submission?"
                confirmButtonText="Delete Submission"
            />
        </>
    );
};

export default SubmissionModal;